<template>
  <div>
    <b-button variant="outline-light" v-on:click="detayaGit()"
      ><Icon
        icon="akar-icons:search"
        width="20"
        height="20"
        v-b-tooltip.hover.bottom="'DETAY'"
        color="#7367F0"
    /></b-button>
    <b-button variant="outline-light" v-on:click="stokEkstre()"
      ><Icon
        icon="material-symbols:receipt-long"
        width="20"
        height="20"
        v-b-tooltip.hover.bottom="'DETAY'"
        color="#FF9F43"
    /></b-button>
    <StokEkstre ref="ekstre" />
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
import StokEkstre from "./StokEkstre.vue";
export default {
  components: { Icon, StokEkstre },
  methods: {
    stokEkstre() {
      this.$store.commit(
        "account/STOKSTOCKNAME_TUT",
        this.params.data.STOCKNAME
      );
      this.$store.commit("account/STOKID_TUT", this.params.data.STOCKID);
      this.$store.commit("account/STOKSTOCKNO_TUT", this.params.data.STOCKNO);
      this.$refs.ekstre.stokEkstreDetay( this.params.data.STOCKNO, this.params.data.STOCKNAME);
      // this.$store.commit("account/STOCKIDALTER_TUT", this.params.data.STOCKIDALTER);
    },
    detayaGit() {
      this.$root.$emit("stokKayitGuncelle", this.params.data);
    }
  }
};
</script>
